
export default {
	methods: {
		async storeInCache() {
			await this.storeDeviceTypesIconInCache()
			
			const { plansJPG } = await this.getSitePlansInIndexedDB()
			await this.storePlansSiteInCache(plansJPG)
			
			localStorage.setItem('pwa-cache-reload', JSON.stringify(false))
		},
		async storeDeviceTypesIconInCache() {
			const { data } = await this.$store.dispatch('pwaDevice/getAllDeviceTypesIcon', {
				access_token: JSON.parse(localStorage.getItem('pwa')).access_token,
			})
			data.map(deviceType => {
				if(deviceType.icon) {
					fetch(deviceType.icon, { mode: 'no-cors' })
				}
			})
		},
		async storePlansSiteInCache(plans) {
			plans.map(plan => {
				const url = plan.url || plan.pdf
				if(url) {
					fetch(url, { mode: 'no-cors' })
				}
			})
		},
	}
}
